import {ValueOf} from "../../types/interfaces";

export enum CardDirection {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical',
}
export type CardDirectionType = `${ValueOf<typeof CardDirection>}`

export const CardClass = {
	root: 'gov-card',
	header: 'gov-card__header',
	arrow: 'gov-card__arrow',
	inner: 'gov-card__inner',
	img: 'gov-card__img',
	icon: 'gov-card__icon',
	content: 'gov-card__content',
	footer: 'gov-card__footer',
}
